import {
  Button,
  Heading,
  MonthCalendar,
  RadioButton,
  Switch,
  Typography,
  WeekCalendar,
} from '@altify/components';

import { daysOfWeek, useContent } from '@altify/utils';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import { useState } from 'react';
import { View } from 'react-native';
import { tradeSharedContent } from '../../../tradeShared.content';
import { RecurringBuyInterval } from '../../models/RecurringBuyInterval';
import { RecurringBuySchedule } from '../../models/RecurringBuySchedule';
import { recurringBuySharedContent } from '../../recurringBuyShared.content';
import { content } from './RecurringBuyScheduleModal.content';

const RecurringBuyScheduleModal = ({
  isOpen = true,
  onClose,
  onSubmit,
  schedule,
}: {
  isOpen: boolean;
  onClose?: () => void;
  onSubmit?: (details: RecurringBuySchedule) => void;
  schedule?: RecurringBuySchedule;
}) => {
  const localizedContent = useContent(
    content,
    recurringBuySharedContent,
    tradeSharedContent,
  );
  const date = new Date();
  const currentWeekDay = daysOfWeek[date.getDay()];
  const currentMonthDay = date.getDate();

  const [buyNow, setBuyNow] = useState(schedule?.buyNow ?? false);
  const [interval, setInterval] = useState<RecurringBuyInterval>(
    schedule?.interval ?? 'weekly',
  );
  const [dayOfMonth, setDayOfMonth] = useState(
    schedule?.interval == 'monthly' ? schedule?.dayOfMonth : currentMonthDay,
  );
  const [dayOfWeek, setDayOfWeek] = useState(
    schedule?.interval == 'weekly' ? schedule?.dayOfWeek : currentWeekDay,
  );

  return (
    <DialogOrBottomSheet
      blurEnabled={true}
      isOpen={isOpen}
      onClose={() => onClose?.()}
      backgroundColor="#0C1C2C"
      footerContent={
        <View className="px-4">
          <Button
            size="large"
            color="primary"
            className="mb-7 mt-3 w-full"
            text={localizedContent.confirmSchedule}
            onPress={() => {
              onSubmit?.(
                interval === 'monthly'
                  ? {
                      interval: 'monthly',
                      dayOfMonth: dayOfMonth,
                      buyNow: buyNow,
                    }
                  : {
                      interval: 'weekly',
                      dayOfWeek: dayOfWeek,
                      buyNow: buyNow,
                    },
              );
              onClose?.();
            }}
          />
        </View>
      }>
      <View className="items-center w-full px-4">
        <Heading level={4} className="text-center w-full">
          {localizedContent.setSchedule}
        </Heading>
        <View className="flex flex-row mt-8 w-full">
          <RadioButton
            selected={interval === 'weekly'}
            className="flex-1 mr-2"
            title={localizedContent.weekly}
            onPress={() => {
              setInterval('weekly');
            }}
          />
          <RadioButton
            className="flex-1 ml-2"
            selected={interval === 'monthly'}
            title={localizedContent.monthly}
            onPress={() => {
              setInterval('monthly');
            }}
          />
        </View>
        {interval === 'weekly' ? (
          <WeekCalendar
            weekDaySelection={dayOfWeek}
            onChange={setDayOfWeek}
            className="w-full mt-8"
          />
        ) : (
          <MonthCalendar
            daySelection={dayOfMonth}
            onChange={setDayOfMonth}
            className="w-full mt-8"
          />
        )}
        <View className="flex flex-row mt-4 w-full items-center mb-1">
          <Typography
            size="large"
            weight="medium"
            className="text-white flex-1">
            {localizedContent.firstPurchaseToday}
          </Typography>
          <Switch
            checked={buyNow}
            onCheckedChange={setBuyNow}
            className="mx-2"
          />
        </View>
      </View>
    </DialogOrBottomSheet>
  );
};

export default RecurringBuyScheduleModal;
